import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bs-invoice-search-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.failed || _ctx.empty)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["bs-invoice-search-state__message", { 'message--failed': _ctx.failed }])
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Поиск данных")
              ], 64))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("При получении данных произошла ошибка")
                ], 64))
              : (_ctx.empty)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.noQuery)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Для начала поиска введите запрос")
                        ], 64))
                      : (_ctx.loaded)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("По вашему запросу ничего не найдено")
                          ], 64))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_bs_loader, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}